import vuesticEn from './locales/vuestic-en'
import vuesticDe from './locales/vuestic-de'
import vuesticFr from './locales/vuestic-fr'
import vuesticNl from './locales/vuestic-nl'
import vuesticBg from './locales/vuestic-bg'
import vuesticHr from './locales/vuestic-hr'
import vuesticIt from './locales/vuestic-it'
import vuesticPt from './locales/vuestic-pt'
import vuesticSk from './locales/vuestic-sk'
import vuesticEs from './locales/vuestic-es'
import vuesticCs from './locales/vuestic-cs'
import vuesticPl from './locales/vuestic-pl'
import vuesticRo from './locales/vuestic-ro'
import vuesticUa from './locales/vuestic-ua'
import vuesticRu from './locales/vuestic-ru'
import vuesticRuKg from './locales/vuestic-ru-kg'
import vuesticTr from './locales/vuestic-tr'
import vuesticFa from './locales/vuestic-fa'
import vuesticArOm from './locales/vuestic-ar-om'
import vuesticEnOm from '@/i18n/locales/vuestic-en-om'

export const vuesticConstants: Record<string, any> = {
  en: vuesticEn,
  de: vuesticDe,
  'en-us': vuesticEn,
  'en-gb': vuesticEn,
  'en-ca': vuesticEn,
  'en-au': vuesticEn,
  'en-in': vuesticEn,
  'en-ke': vuesticEn,
  'en-za': vuesticEn,
  'de-at': vuesticDe,
  'de-ch': vuesticDe,
  fr: vuesticFr,
  'fr-ca': vuesticFr,
  'fr-ch': vuesticFr,
  nl: vuesticNl,
  bg: vuesticBg,
  hr: vuesticHr,
  it: vuesticIt,
  pt: vuesticPt,
  'pt-br': vuesticPt,
  sk: vuesticSk,
  es: vuesticEs,
  'es-pe': vuesticEs,
  cs: vuesticCs,
  pl: vuesticPl,
  ro: vuesticRo,
  uk: vuesticUa,
  ru: vuesticRu,
  'ru-kg': vuesticRuKg,
  tr: vuesticTr,
  fa: vuesticFa,
  'ar-om': vuesticArOm,
  'en-om': vuesticEnOm,
}

export const supportedLanguages = Object.keys(vuesticConstants)
